import { translate } from '@/services/translations'
const $gettext = translate.gettext.bind(translate)

const ONE_TIME = 'ONE_TIME'
const RECURRING = 'RECURRING'

const FREQUENCY_CHOICES = [
  {
    value: RECURRING,
    label: $gettext('Each pay period'),
  },
  {
    value: ONE_TIME,
    label: $gettext('One time'),
  },
]

export default {
  ONE_TIME,
  RECURRING,
  FREQUENCY_CHOICES,
}
